/**
 * Supported languages configuration
 * Each language has a code, English name, and native name
 */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', englishName: 'English', nativeName: 'English' },
  { code: 'de', englishName: 'German', nativeName: 'Deutsch' },
  { code: 'es', englishName: 'Spanish', nativeName: 'Español' },
  { code: 'fr', englishName: 'French', nativeName: 'Français' },
  { code: 'it', englishName: 'Italian', nativeName: 'Italiano' },
  { code: 'pl', englishName: 'Polish', nativeName: 'Polski' },
  { code: 'pt', englishName: 'Portuguese', nativeName: 'Português' },
  { code: 'ru', englishName: 'Russian', nativeName: 'Русский' },
];

/**
 * Get language object by code
 * @param {string} code - Language code (e.g., 'en', 'de')
 * @returns {Object|undefined} Language object or undefined
 */
export const getLanguageByCode = (code) => {
  return SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
};

/**
 * Get display label for a language (native name)
 * @param {string} code - Language code
 * @returns {string|null} Native name or null if not found
 */
export const getLanguageLabel = (code) => {
  const lang = getLanguageByCode(code);

  return lang ? lang.nativeName : null;
};
